import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchQuotationData, fetchQuotationTemplates, fetchQuotationNoteList, fetchMaterialDataUnit } from "../../Thunks/QuotationThunks";
import { Quotation, MaterialDataUnit } from "../../Types/Quotation/QuotationType";
import { QuotationTemplate } from "../../Types/Quotation/QuotationTemplate";
import { QuotationNote } from "../../Types/Quotation/QuotationNoteType";

interface QuotationSlice {
    loadingQuotation: boolean;
    quotations: Quotation[];
    errorQuotation: string | null;

    loadingQuotationTemplate: boolean;
    quotationTemplates: QuotationTemplate[];
    errorQuotationTemplate: string | null;

    loadingQuotationNoteList: boolean;
    quotationNoteList: QuotationNote[];
    errorQuotationNoteList: string | null;

    loadingMaterialDataUnit: boolean;
    materialDataUnits: MaterialDataUnit[];
    errorMaterialDataUnit: string | null;
}

const initialState: QuotationSlice = {
    loadingQuotation: false,
    quotations: [],
    errorQuotation: null,

    loadingQuotationTemplate: false,
    quotationTemplates: [],
    errorQuotationTemplate: null,

    loadingQuotationNoteList: false,
    quotationNoteList: [],
    errorQuotationNoteList: null,

    loadingMaterialDataUnit: false,
    materialDataUnits: [],
    errorMaterialDataUnit: null
};

const quotationSlice = createSlice({
    name: "quotationSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            /* Quotations */
            .addCase(fetchQuotationData.pending, (state) => {
                state.loadingQuotation = true;
                state.errorQuotation = null;
            })
            .addCase(fetchQuotationData.fulfilled, (state, action: PayloadAction<Quotation[]>) => {
                state.quotations = [];
                state.loadingQuotation = false;
                state.quotations = action.payload;
            })
            .addCase(fetchQuotationData.rejected, (state, action) => {
                state.loadingQuotation = false;
                state.errorQuotation = action.error.message || "Failed to fetch quotations";
            })

            /* Quotation templates */
            .addCase(fetchQuotationTemplates.pending, (state) => {
                state.loadingQuotationTemplate = true;
                state.errorQuotationTemplate = null;
            })
            .addCase(fetchQuotationTemplates.fulfilled, (state, action: PayloadAction<QuotationTemplate[]>) => {
                state.quotationTemplates = [];
                state.loadingQuotationTemplate = false;
                state.quotationTemplates = action.payload;
            })
            .addCase(fetchQuotationTemplates.rejected, (state, action) => {
                state.loadingQuotationTemplate = false;
                state.errorQuotationTemplate = action.error.message || "Failed to fetch quotation templates";
            })

            /* Quotation note list */
            .addCase(fetchQuotationNoteList.pending, (state) => {
                state.loadingQuotationNoteList = true;
                state.errorQuotationNoteList = null;
            })
            .addCase(fetchQuotationNoteList.fulfilled, (state, action: PayloadAction<QuotationNote[]>) => {
                state.quotationNoteList = [];
                state.loadingQuotationNoteList = false;
                state.quotationNoteList = action.payload;
            })
            .addCase(fetchQuotationNoteList.rejected, (state, action) => {
                state.loadingQuotationNoteList = false;
                state.errorQuotationNoteList = action.error.message || "Failed to fetch material data units.";
            })

            /* Material data unit */
            .addCase(fetchMaterialDataUnit.pending, (state) => {
                state.loadingMaterialDataUnit = true;
                state.errorMaterialDataUnit = null;
            })
            .addCase(fetchMaterialDataUnit.fulfilled, (state, action: PayloadAction<MaterialDataUnit[]>) => {
                state.materialDataUnits = [];
                state.loadingMaterialDataUnit = false;
                state.materialDataUnits = action.payload;
            })
            .addCase(fetchMaterialDataUnit.rejected, (state, action) => {
                state.loadingMaterialDataUnit = false;
                state.errorMaterialDataUnit = action.error.message || "Failed to fetch material data units.";
            });
    },
});

export const { } = quotationSlice.actions
export default quotationSlice.reducer;
